import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {TableOptions} from "../../../../shared-kernel/components/Table";
import {
  createAdapterToConceptGroup,
  createAdapterToConceptGroupEndpoint,
  createAdapterToFieldConceptGroupEndpoint
} from "../adapters/conceptGroup.adapter";
import {ConceptGroup, ConceptGroupEndpoint, EndpointConceptGroupList} from "../domain/ConceptGroup.model";
import { appConfig } from "../../../../config";
import { EndpointConceptGroup } from "../domain/ConceptGroup.model";
import { createAdapterToFilterBackend } from "../../../../utilities/paramsAdapter";

const BASE_CONCEPT_URL = '/entidadesfinancieras/gruposConcepto'
const BASE_CONCEPT_MUTATION_URL = '/entidadesfinancieras/gruposConcepto'
export const BASE_EXPORT_URL = `${appConfig.API_NODE_URL}/entidadesfinancieras/gruposConcepto/export`;

export const conceptGroupsApi = createApi({
  reducerPath: "conceptGroupsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: appConfig.API_NODE_URL,
    prepareHeaders: (headers: Headers) => {
      const APP_TOKEN = "app_token";
      const token = localStorage.getItem(APP_TOKEN);

      if (token) {
        headers.set("authorization", `${token}`);
      }

      return headers;
    },
    credentials: "include",
  }),
  refetchOnMountOrArgChange: true,
  tagTypes: ["Concepts", "Concept"],
  endpoints: (builder) => ({
    getConceptGroup: builder.query<ConceptGroup, number | undefined>({
      query: (id) => `${BASE_CONCEPT_URL}/${id}`,
      transformResponse: (response: EndpointConceptGroup) => {
        return createAdapterToConceptGroup(response.Content)
      },
      providesTags: (_res, _err, id) => [{type: "Concept", id: id?.toString()}],
    }),
    getConceptGroups: builder.query<any, TableOptions<ConceptGroup>|undefined>({
      query: (params: TableOptions<ConceptGroup>) => {
        const { page, pageSize, order, search, filters } = params || {};
        const adaptersFilter = filters?.map( f => createAdapterToFilterBackend(f,createAdapterToFieldConceptGroupEndpoint))
        const serializedFilters = adaptersFilter ? JSON.stringify(adaptersFilter) : undefined;
        const serializedOrder = order ? JSON.stringify({field:createAdapterToFieldConceptGroupEndpoint(order.field), order:order.order}) : undefined;
        return {
          url:`${BASE_CONCEPT_URL}`,
          params: {
            page:page? page - 1: 0,
            pageSize,
            order: serializedOrder,
            search,
            filters:serializedFilters
          },
        }
      },
      transformResponse: (response: EndpointConceptGroupList) => {
        const endpointResponse = response.Content.map((conceptGroup: ConceptGroupEndpoint) => createAdapterToConceptGroup(conceptGroup));
        return endpointResponse;
      },
    providesTags: ["Concepts"],
    }),
    createConceptGroup: builder.mutation<any, ConceptGroup>({
      query: (data) => ({
        url: `${BASE_CONCEPT_MUTATION_URL}`,
        method: "POST",
        body: {
          "Content": createAdapterToConceptGroupEndpoint(data)
        },
      }),
      invalidatesTags: ["Concepts"],
    }),
    updateConceptGroup: builder.mutation<any, ConceptGroup>({
      query: (data: ConceptGroup) => ({
        url: `${BASE_CONCEPT_MUTATION_URL}`,
        method: "PUT",
        body: {
          "Content": createAdapterToConceptGroupEndpoint(data)
        },
      }),
      invalidatesTags: (_res, _err, data: ConceptGroup) => ["Concepts", {type: 'Concept', id: data?.id?.toString()}],
    }),
    deleteConceptGroup: builder.mutation<void, number>({
      query: (id) => ({
        url: `${BASE_CONCEPT_MUTATION_URL}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Concepts"],
    }),
  }),
});

export const {
  useGetConceptGroupQuery,
  useGetConceptGroupsQuery,
  useCreateConceptGroupMutation,
  useUpdateConceptGroupMutation,
  useDeleteConceptGroupMutation
} = conceptGroupsApi;
